module.exports = __webpack_public_path__ + "static/media/Atharva_Mutsaddi.3c35b129.jpg";